import {Grid} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {DropdownListWidgetConfig} from '@yandex-delivery/form'
import {Select} from '@yandex-delivery/form'
import React, {memo} from 'react'

const grid = css`
  margin-block-end: ${spacing(1)};
`

export const DropdownListWidget = memo(
  ({form_state_key, options, placeholder}: DropdownListWidgetConfig): React.ReactElement | null => {
    const i18n = useI18n()
    const optionsForSelect =
      form_state_key === 'due_date'
        ? options.map(option => ({
            label: option.label.items[0]?.text.replaceAll('-', '.'),
            value: option.value,
          }))
        : options.map(option => ({
            label: option.label.items[0]?.text,
            value: option.value,
          }))
    const defaultPlaceholder =
      form_state_key === 'due_date'
        ? i18n('cargo.create.due.select-date', 'Выберите дату')
        : i18n('ndd.delivery-policy.input.time.placeholder', 'Выберите интервал')

    return (
      <Grid className={grid} item xs>
        <Select<string>
          name={form_state_key}
          options={optionsForSelect}
          placeholder={placeholder || defaultPlaceholder}
          shouldUnregister
        />
      </Grid>
    )
  },
)
